var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mainContent",staticClass:"main-content"},[_c('router-view',{key:_vm.key})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }